import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';
import moment from 'moment/moment';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
import './Resources/dashboard.css';


function SP_edit_sales(){

  


   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{
   */}


    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[Tbrokers,setTbrokers] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();

//booking_number
const[booking_number,setbooking_number]=useState();const updatebooking_number = (event) => { setbooking_number(event.target.value);}; const[booking_number_er,setbooking_number_er]=useState();
//banknm_id
const[banknm_id,setbanknm_id]=useState();const updatebanknm_id = (event) => { setbanknm_id(event.target.value);}; const[banknm_id_er,setbanknm_id_er]=useState();


//date
const[date,setdate]=useState();const updatedate = (event) => { setdate(event.target.value);}; const[date_er,setdate_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
//particular
const[particular,setparticular]=useState();const updateparticular = (event) => { setparticular(event.target.value);}; const[particular_er,setparticular_er]=useState();
//amount
const[amount,setamount]=useState();const updateamount = (event) => { setamount(event.target.value);}; const[amount_er,setamount_er]=useState();
//bank_id
const[bank_id,setbank_id]=useState();const updatebank_id = (event) => { setbank_id(event.target.value);}; const[bank_id_er,setbank_id_er]=useState();
//mode
const[mode,setmode]=useState();const updatemode = (event) => { setmode(event.target.value);}; const[mode_er,setmode_er]=useState();
//commodity
const[commodity,setcommodity]=useState();const updatecommodity = (event) => { const selectedCommodity = event.target.value; setcommodity(selectedCommodity);
  // use main rate field
  syncCommodityWithProduct(selectedCommodity, rate);
}; const[commodity_er,setcommodity_er]=useState();
//quantity
const[quantity,setquantity]=useState();const updatequantity = (event) => { setquantity(event.target.value); setQuantity(); }; const[quantity_er,setquantity_er]=useState();
//rate
const[rate,setrate]=useState();const updaterate = (event) => { setrate(event.target.value); setQuantity(); 
    const newRate = event.target.value;   // ✅ define it
  setrate(newRate); syncCommodityWithProduct(commodity, newRate); }; const[rate_er,setrate_er]=useState();
//value
const[value,setvalue]=useState();const updatevalue = (event) => { setvalue(event.target.value); setQuantity(); }; const[value_er,setvalue_er]=useState();
//bcode
const[bcode,setbcode]=useState();const updatebcode = (event) => { setbcode(event.target.value);}; const[bcode_er,setbcode_er]=useState();
//vendor_name
const[vendor_name,setvendor_name]=useState();const updatevendor_name = (event) => { setvendor_name(event.target.value); getVendorbyName(); }; const[vendor_name_er,setvendor_name_er]=useState();

//checkboxes
const [p1, setP1] = useState(false);
const [p2, setP2] = useState(false);
const [p3, setP3] = useState(false);
const [p4, setP4] = useState(false);
const [p5, setP5] = useState(false);
const [p6, setP6] = useState(false);

const [rate1, setRate1] = useState(0);  const[rate1_er,setrate1_er]=useState();
const [rate2, setRate2] = useState(0);  const[rate2_er,setrate2_er]=useState();
const [rate3, setRate3] = useState(0);  const[rate3_er,setrate3_er]=useState();
const [rate4, setRate4] = useState(0);  const[rate4_er,setrate4_er]=useState();
const [rate5, setRate5] = useState(0);  const[rate5_er,setrate5_er]=useState();
const [rate6, setRate6] = useState(0);  const[rate6_er,setrate6_er]=useState();

const toggleP1 = () => {if (p1) setRate1(0); setP1(!p1);};
const toggleP2 = () => {if (p2) setRate2(0); setP2(!p2);};
const toggleP3 = () => {if (p3) setRate3(0); setP3(!p3);};
const toggleP4 = () => {if (p4) setRate4(0); setP4(!p4);};
const toggleP5 = () => {if (p5) setRate5(0); setP5(!p5);};
const toggleP6 = () => {if (p6) setRate6(0); setP6(!p6);};

//setting default rate from the select bar
// setting default rate from the select bar
function syncCommodityWithProduct(selectedCommodity, baseRate) {
  const r = parseFloat(baseRate || 0);

  switch (selectedCommodity) {
    case "sugar S30":
      if (!p1) setP1(true);   // tick only if not already selected
      setRate1(r);
      break;

    case "sugar M30":
      if (!p2) setP2(true);
      setRate2(r);
      break;

    case "sugar S super":
      if (!p3) setP3(true);
      setRate3(r);
      break;

    case "sugar M super":
      if (!p4) setP4(true);
      setRate4(r);
      break;

    case "molasis":
      if (!p5) setP5(true);
      setRate5(r);
      break;

    case "brown sugar":
      if (!p6) setP6(true);
      setRate6(r);
      break;

    default:
      break;
  }
}




//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


function setQuantity(){

    const rate = parseFloat(document.getElementById("rate").value);
    const quantity = parseFloat(document.getElementById("quantity").value);
    let val = rate*quantity;
    setvalue(val);
}

useEffect(()=>{
   
  getData();
  
  },[])
 

  //FILTER VARIABLES
  const[filter_val,setfilter_val] = useState(0);
    
  //Variables for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
  
  
//Edit Function
function getData(){
 
  const bankid = sessionStorage.getItem("Bankid00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(bankid>0)){
 
 
 axios.post("salesdetails", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Edit_id:bankid,

 })
 .then((response) => {



  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("Bankid00");


     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   setdate(response.data.booking_date);
   setbooking_number(response.data.booking_number);
   settype(response.data.type);
   setparticular(response.data.particular);
   setamount(response.data.amount);
   setmode(response.data.mode);
   setbank_id(response.data.bank_id);
   setbanknm_id(response.data.bank_name);
   setcommodity(response.data.commodity); 
   setquantity(response.data.quantity);
   setrate(response.data.rate);
   setvalue(response.data.value);
   setamount(response.data.amount);
   setbcode(response.data.bcode);
   setvendor_name(response.data.vendor_name);

   
  // 🔥 IMPORTANT: rates from backend
  setRate1(response.data.rate1 || 0);
  setRate2(response.data.rate2 || 0);
  setRate3(response.data.rate3 || 0);
  setRate4(response.data.rate4 || 0);
  setRate5(response.data.rate5 || 0);
  setRate6(response.data.rate6 || 0);

  // 🔥 AUTO-TICK CHECKBOXES BASED ON RATE
  setP1((response.data.rate1 ?? 0) > 0);
  setP2((response.data.rate2 ?? 0) > 0);
  setP3((response.data.rate3 ?? 0) > 0);
  setP4((response.data.rate4 ?? 0) > 0);
  setP5((response.data.rate5 ?? 0) > 0);
  setP6((response.data.rate6 ?? 0) > 0);

  }
  //Cannot Fetch Data
  else{


      document.getElementById("edit-form").style.display="none";

     //Setting Variables to empty 
     setdate_er(" ");settype_er(" ");setparticular_er(" ");setamount_er(" ");setbank_id_er();seterror_msg(" ");   
     setdate(" ");settype(" ");setparticular(" ");setamount(" ");setbank_id();setbanknm_id();
     setmode(" ");setcommodity(" ");setquantity(" ");setrate(" ");setvalue(" ");setbcode(" ");setvendor_name(" ");

      document.getElementById("edit-error-card").style.display="block"; 
      sessionStorage.removeItem("Bankid00");
  }
 
 
 });
 
 }
 //User not Logedin
 else{

     //Checking if user loggedin
     if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))){
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
     }
 
  }
 
 }
  
 //******************* GET SALES DATA BY ID FUNCTION END  ********************//

 
 
  
//******************* CREATE SALES FUNCTION START ********************//
function createsales(){

  //Setting Error Variables
setdate_er(" ");settype_er(" ");setparticular_er(" ");setamount_er(" ");
setmode_er(" ");setcommodity_er(" ");setquantity_er(" ");setrate_er(" ");setvalue_er(" ");setbcode_er(" ");setvendor_name_er(" ");
seterror_msg(" ");



if(amount>value){
    setamount_er("Amount cannot be Greater than Booking Value");
    return;
}


  const bankid = sessionStorage.getItem("Bankid00");
  const trno = sessionStorage.getItem("Trno00");



  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    
  const addBtn = document.getElementById("emp-submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional
 
  axios.post("editsalesdetails", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Date : moment(date).format('YYYY-MM-DD'),
   Type:type,
   Bank_id:bank_id,
   Particular : particular,
   Amount : amount,
   Mode: mode,
   Commodity:commodity,
   Rate:rate,
   Quantity:quantity,
   Bcode:bcode,
   Vendor_name:ven_name,
   Rate1:rate1,
   Rate2:rate2,
   Rate3:rate3,
   Rate4:rate4,
   Rate5:rate5,
   Rate6:rate6,
   Edit_id:bankid,
   Tr_no:trno,
   
   
   

 })
 .then((response) => {

  console.log(trno);
  console.log(bankid);
  console.log(response.data.Tr_no);
    console.log(response.data.Btrno);
    console.log(response.data);

    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "submit";

    //Transaction Limit Reached
    if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  // else if(response.data.error==103){     seterror_msg(response.data.error_msg); return; }


  //Invalid Session
  else if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
else if(response.data.validatorerror){
  setdate_er(response.data.validatorerror.Date);
  settype_er(response.data.validatorerror.Type);
  setparticular_er(response.data.validatorerror.Particular);
  setamount_er(response.data.validatorerror.Amount);
  setmode_er(response.data.validatorerror.Mode);
  setquantity_er(response.data.validatorerror.Quantity);
  setrate_er(response.data.validatorerror.Rate);
  setbcode_er(response.data.validatorerror.Bcode);
  setvendor_name_er(response.data.validatorerror.Vendor_name);
  setcommodity_er(response.data.validatorerror.Commodity);
}
//Invalid Entries
else if(response.data.error==102){ 
  
  setdate_er(response.data.date_er);
  settype_er(response.data.type_er);
  setparticular_er(response.data.particular_er);
  setamount_er(response.data.amount_er);
  setmode_er(response.data.mode_er);
  setquantity_er(response.data.quantity_er);
  setrate_er(response.data.rate_er);
  setbcode_er(response.data.bcode_er);
  setvendor_name_er(response.data.vendor_name_er);
  setcommodity_er(response.data.commodity_er);
  seterror_msg("Cannot Add Transaction!");  }


  //Invalid Entries
  else if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Entered Successfully
  else if(response.data.successvar==1){        document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Transaction !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* CREATE SALES FUNCTION END ********************//


 
const[vdata,setvdata] = useState([]);//SetData Variable
 //ven_name
const[ven_name,setven_name]=useState();const updateven_name = (event) => { setven_name(event.target.value);}; const[ven_name_er,setven_name_er]=useState();

//******************* GET VENDOR BY NAME FUNCTION START  ********************//
function getVendorbyName(){
 
  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
      //Fetching Filter Variables
      const $vname = document.getElementById("vendor_name").value;

      

if ($vname.trim().length < 3) {
  setvendor_name_er("type atleast 3 characters to search vendor");
}
else{
 
 axios.post("vendorslistspr", {
   Log_id:logid,
   Token:token,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   //Filters
   Filter_val : filter_val,
   Name : $vname,
  'page' : pageNumber

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setvdata(response.data.vendors);


  }
   //FILTER DATA
  //Validation Errors
  else if(response.data.validatorerror){
    seterror_msg("Cannot Fetch Vendor Data !");
  }

  //Data Violation
  else if(response.data.error==102){ 
  
    seterror_msg("Cannot Fetch Vendor Data !");

  }
  //Cannot Fetch Data
  else{
   //seterror_msg("Cannot Fetch Vendor Data !");
   return;
  }
 
 
 });
 
}
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 }
  
 //******************* GET VENDOR BY NAME FUNCTION END ********************//


return(
    <>
    <html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>React App</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div class="main-panel">

      

             {/* SUCCESS CARD START */}
          <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Transaction Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="/spadminpanel-dashboard-sales"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* SUCCESS CARD END */}

                <div class="content-wrapper pb-0">
          

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Sales  (Sauda Book) | Edit</p>
                  </a>
                 
                </div>
          
              </div>
            </div>

                <div class="card">
               
                  <div class="card-body">
                    <h4 class="card-title">Sales Transaction</h4>
                    <div class="form-sample">
                      <p class="card-description">enter your sales transactions here</p>
                      <code>{error_msg}</code>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type Vendor Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Manoj Kumar" id="vendor_name" value={vendor_name} onChange={updatevendor_name} />
                              <code>{vendor_name_er}</code>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Vendor Name<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Vendor" style={{padding:"1rem"}} id="ven_name" value={ven_name} onChange={updateven_name}>
                               <option value="">Select Vendor</option>
                              {
                              vdata.map((curElm4,ind)=>{

                              return(
                              <>
                              <option value={curElm4.Trade_name}>{curElm4.Trade_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              
                              <code>{ven_name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Booking Date<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={date} onChange={updatedate} />
                              <code>{date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Transaction" id="type" value={type} onChange={updatetype}>
                              <option value="">Select Type</option>
                              <option value="forward">forward</option>
                              <option value="direct">direct</option>
                              <option value="broker">broker</option>
                              </select>
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Primary Commodity<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="commodity" value={commodity} onChange={updatecommodity} style={{padding:"1rem"}}>
                              <option value="">Select Commodity</option>
                             {/*} <option value="sugar S">sugar S</option> */}
                              <option value="sugar S30">sugar S30</option>
                             {/*} <option value="sugar M">sugar M</option> */}
                              <option value="sugar M30">sugar M30</option>
                              <option value="molasis">molasis</option>
                              <option value="brown sugar">brown sugar</option>
                              <option value="sugar M super">sugar M super</option>
                              <option value="sugar S super">sugar S super</option>
                              </select>
                              <code>{commodity_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Broker<code>*</code></label>
                            <div class="col-sm-9">
                               <select class="form-control" placeholder="Select Broker" style={{padding:"1rem"}} id="bcode" value={bcode} onChange={updatebcode}>
                               <option value="">Select Broker</option>
                              {
                              Tbrokers.map((curElm3,ind)=>{

                              return(
                              <>
                              <option value={curElm3.Bcode}>{curElm3.Bcode}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              
                              <code>{bcode_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Quantity<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50.00" id="quantity" value={quantity} onChange={updatequantity} />
                              <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Rate<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="36.00" id="rate" value={rate} onChange={updaterate} />
                              <code>{rate_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                      <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Booking Value<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50.00" id="value" value={value} onChange={updatevalue} readonly />
                              <code>{value_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Deposit<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="amount" value={amount} onChange={updateamount} />
                              <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Mode<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Mode" id="mode" value={mode} onChange={updatemode}>
                              <option value="">Select Mode</option>
                              <option value="bpm">bpm</option>
                              <option value="bank">bank</option>
                              </select>
                              <code>{mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Bank<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Bank" style={{padding:"1rem"}} id="bank_id" value={bank_id} onChange={updatebank_id}>
                              <option value="">Select Bank</option>
                              {
                              Tbanks.map((curElm2,ind)=>{

                              return(
                              <>
                              <option value={curElm2.Bank_id}>{curElm2.Bank_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              <code>{bank_id_er}</code>
                            </div>
                          </div>
                        </div>                      
                      </div>
                      <h5>Select Products and Booking Rates</h5>
                        <div class="row">
                        <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p1} onChange={toggleP1} />
                          <label>sugar S30</label>
                        </div>
                        </div>
                        <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p2} onChange={toggleP2} />
                          <label>sugar M30</label>
                        </div>
                        </div>
                        <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p3} onChange={toggleP3} />
                          <label>sugar S Super</label>
                        </div>
                        </div>
                        <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p4} onChange={toggleP4} />
                          <label>sugar M Super</label>
                        </div>
                        </div>
                        <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p5} onChange={toggleP5} />
                          <label>Molasis</label>
                        </div>
                        </div>
                         <div class="col-md-2">
                           <div class="form-check">
                          <input type="checkbox" checked={p6} onChange={toggleP6} />
                          <label>Brown Sugar</label>
                        </div>
                        </div>
                        </div>
                         <div class="row">
                        {p1 && ( <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">sugar S30 Rate</label>
                            <div class="col-sm-9">
                                 
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate1} onChange={(e) => setRate1(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>)}
                         {p2 && (<div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">sugar M30 Rate</label>
                            <div class="col-sm-9">
                                  
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate2} onChange={(e) => setRate2(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>)}
                        </div>
                        <div class="row">
                        {p3 && (<div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">sugar S Super Rate</label>
                            <div class="col-sm-9">
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate3} onChange={(e) => setRate3(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>
                        )}
                         {p4 && (<div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">sugar M Super Rate</label>
                            <div class="col-sm-9">
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate4} onChange={(e) => setRate4(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>)}
                        </div>
                        <div class="row">
                        {p5 && (<div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Molasis</label>
                            <div class="col-sm-9">
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate5} onChange={(e) => setRate5(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>
                        )}
                        {p6 && (<div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Brown Sugar</label>
                            <div class="col-sm-9">
                                  <input type="text" class="form-control mb-2" placeholder="10.00" value={rate6} onChange={(e) => setRate6(e.target.value)}/>
                                  <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>
                        )}
                        </div>

                      
                         <div class="row">
                     
                      
                      </div>
                        <div class="form-group">
                        <label for="exampleTextarea1">Particular<code>*</code></label>
                        <textarea class="form-control" rows="2" id="particular" value={particular} onChange={updateparticular} ></textarea>
                        <code>{particular_er}</code>
                      </div>
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}}  id="emp-submit-btn" onClick={createsales}>Submit</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>

                    
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default SP_edit_sales;